/**
 * Shared auth helper for per-case Modal container requests.
 *
 * All container endpoints require a Supabase JWT in the Authorization header.
 */

import { supabase } from '@/lib/supabase/client';

export const CONTAINER_BASE =
  'https://app-iii-partners--settlewise-case-container-serve-case.modal.run';

/**
 * Get Authorization headers with the current Supabase JWT.
 * Throws if no active session exists.
 */
export async function getContainerAuthHeaders(): Promise<Record<string, string>> {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session?.access_token) {
    throw new Error('Not authenticated — no active session');
  }
  return { Authorization: `Bearer ${session.access_token}` };
}

/**
 * Make an authenticated fetch to the container.
 */
export async function containerFetch(
  path: string,
  init?: RequestInit,
): Promise<Response> {
  const authHeaders = await getContainerAuthHeaders();
  return fetch(`${CONTAINER_BASE}${path}`, {
    ...init,
    headers: {
      ...authHeaders,
      ...(init?.headers || {}),
    },
  });
}
